
export default {
    'info': 'mdi-information',
    'warning': 'mdi-alert'
}
